import { useAuth } from "./use-auth";

export type Role = "admin" | "member";

export function usePermissions() {
  const { user } = useAuth();
  const currentCompanyRole = user?.company?.role as Role;

  const isAdmin = currentCompanyRole === "admin";
  const isMember = currentCompanyRole === "member";

  return {
    role: currentCompanyRole,
    isAdmin,
    isMember,
  };
}
